<script lang="ts">
import { DEFAULT_SIMPLE_STAT_BLOCK } from '@/bases.ts'
import { useDesignStore } from '@/stores/designStore.ts'
import _ from 'lodash'
import { ref } from 'vue'
import StatBlockDetailedReference from './StatBlockDetailedReference.vue'
import StatBlockSimplifiedReference from './StatBlockSimplifiedReference.vue'
import CustomModal from '@/components/CustomModal.vue'
import GridSelect from '@/components/GridSelect.vue'

export default {
  props: ['currentStatBlock', 'lightenDarkenColor'],
  setup(props, context) {
    const designStore = useDesignStore()
    const statBlock = ref(_.cloneDeep(DEFAULT_SIMPLE_STAT_BLOCK))

    function goBack() {
      context.emit('return')
    }
    const isEditing = ref(true)
    const selectTypeModal = ref(true)
    const isSimple = ref(true)
    const options = [
      {
        name: 'Simple Stat Block',
        value: true,
        icon: 'gi-minions',
        description:
          'A Stat Block designed to present all information at a glance.  Simplified Statblocks are good for monsters or NPCs with a handful of abilities.'
      },
      {
        name: 'Complex Statblock',
        icon: 'gi-barbarian',
        value: false,
        description:
          'A Stat Block designed for complex opponents with character like diversity in moveset. Complex Stat Blocks additionally can have Versions which represent multiple different states.'
      }
    ]
    return {
      goBack,
      designStore,
      props,
      statBlock,
      isEditing,
      isSimple,
      selectTypeModal,
      options
    }
  },
  components: {
    StatBlockDetailedReference,
    StatBlockSimplifiedReference,
    CustomModal,
    GridSelect
  }
}
</script>
<template>
  <div>
    <CustomModal
      :showModal="selectTypeModal"
      title="Select Stat Block Variety"
      @close="selectTypeModal = false"
    >
      <template v-slot:body>
        <GridSelect
          :updateOption="
            (val) => {
              isSimple = val
              selectTypeModal = false
            }
          "
          :selected="isSimple"
          :options="options"
        ></GridSelect> </template
    ></CustomModal>
    <StatBlockDetailedReference
      v-if="!isSimple"
      :is-editing="isEditing"
      :current-stat-block="statBlock"
      :lightenDarkenColor="props.lightenDarkenColor"
      :goBack="goBack"
    ></StatBlockDetailedReference>

    <StatBlockSimplifiedReference
      v-if="isSimple"
      :is-editing="isEditing"
      :omit-version-control="true"
      :current-stat-block="statBlock"
      :lightenDarkenColor="props.lightenDarkenColor"
      :goBack="goBack"
    >
    </StatBlockSimplifiedReference>
  </div>
</template>
<style></style>
